import React from 'react'
import './ShimmerUI.scss'

function ShimmerUI() {
  return (
    <div className='shimmer-ui'>
        <div className="box">
            <div className="image"></div>
            <div className="line1"></div>
            <div className="line2"></div>
        </div>
        <div className="box">
            <div className="image"></div>
            <div className="line1"></div>
            <div className="line2"></div>
        </div>
        <div className="box">
            <div className="image"></div>
            <div className="line1"></div>
            <div className="line2"></div>
        </div>
        <div className="box">
            <div className="image"></div>
            <div className="line1"></div>
            <div className="line2"></div>
        </div>
        <div className="box">
            <div className="image"></div>
            <div className="line1"></div>
            <div className="line2"></div>
        </div>
        <div className="box">
            <div className="image"></div>
            <div className="line1"></div>
            <div className="line2"></div>
        </div>
        <div className="box">
            <div className="image"></div>
            <div className="line1"></div>
            <div className="line2"></div>
        </div>
        <div className="box">
            <div className="image"></div>
            <div className="line1"></div>
            <div className="line2"></div>
        </div>
    </div>
  )
}

export default ShimmerUI